import { DEFAULT_DEADLINE_VALUE } from 'shared/reducers/filter/helpers';
import { getFilteredResidentialComplexes } from 'shared/services/getFilteredResidentialComplexes';
import { ERoom, type IFilter } from 'shared/types/filter';
import { type ITypedReduxAction } from 'shared/types/redux/actionType';
import { type TThunkAction } from 'shared/types/redux/thunk';

export enum EResidentialComplexesIdsTypes {
  ResidentialComplexesIdsChange = 'RESIDENTIAL_COMPLEXES/CHANGE_IDS',
}

export type TResidentialComplexesIdsChange = ITypedReduxAction<
  EResidentialComplexesIdsTypes.ResidentialComplexesIdsChange,
  number[]
>;

export function residentialComplexesIdsChange(filter: IFilter): TThunkAction<Promise<void>> {
  return async (dispatch, _getState, context) => {
    try {
      const residentialComplexesIds = await getFilteredResidentialComplexes({
        context,
        parameters: {
          buildYear: filter.deadline === DEFAULT_DEADLINE_VALUE ? undefined : filter.deadline,
          handOver: filter.readyApartments,
          hasDecoration: filter.apartmentsWithDecoration,
          location: filter.location,
          priceMax: filter.maxPrice,
          priceMin: filter.minPrice,
          room: filter.rooms.includes(ERoom.ThreeRoom)
            ? [...filter.rooms, 'fourRoom', 'fiveRoom', 'large']
            : filter.rooms,
          seriaPlus: filter.seriaPlus,
          totalAreaMax: filter.maxArea,
          totalAreaMin: filter.minArea,
        },
      });

      dispatch({
        payload: residentialComplexesIds,
        type: EResidentialComplexesIdsTypes.ResidentialComplexesIdsChange,
      });
    } catch (error) {
      console.error(error);
    }
  };
}
